<template>
  <Fragment>
    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-6 col-md-5">
        Tire Checks<br /><span>per month</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-lg-2">
        <Money
          v-model="form.numberOfChecks"
          class="form-control form-control-lg"
          type="text"
          v-bind="masks.number"
          required
          @input="onFieldChange($event, maintenance.numberOfChecks)"
        />
      </StepInputGroup>
      <HelpIcon>
        Typical manual tire pressure programs plan for an inflation check of
        each tire at least once per week.
      </HelpIcon>
    </div>

    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-6 col-md-5">
        Time per Check<br />
        <span>minutes</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-lg-2">
        <Money
          v-model="form.laborTime"
          v-bind="masks.number"
          required
          class="form-control form-control-lg"
          type="text"
          @input="onFieldChange($event, maintenance.laborTime)"
        />
      </StepInputGroup>
      <HelpIcon>
        Based on November 2003 FMCSA study, it takes 30 min once per week to
        check 18 tires. 30/18 tires = 1.66min/tire x 8 trailer tires =
        13.3min/trailer tire check
      </HelpIcon>
    </div>
    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-6 col-md-5">
        Avg. Hourly Labor Rate<br /><span>USD</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-lg-2">
        <Money
          v-model="form.laborRate"
          class="form-control form-control-lg"
          type="text"
          v-bind="masks.money"
          required
          @input="onFieldChange($event, maintenance.laborRate)"
        />
      </StepInputGroup>
      <div class="col-2 input-group"></div>
    </div>
  </Fragment>
</template>

<script>
import { Money } from 'v-money';
import { Fragment } from 'vue-frag';

import HelpIcon from '../step-elements/HelpIcon.vue';
import StepFieldLabel from '../step-elements/StepFieldLabel.vue';
import StepInputGroup from '../step-elements/StepInputGroup.vue';
import { mapState, mutation, masks } from '../store';
import { defaultMaintenance } from '../store/state';

export default {
  name: 'Maintenance',

  components: { Money, Fragment, HelpIcon, StepInputGroup, StepFieldLabel },

  data() {
    return {
      /** @type {Maintenance} */
      form: defaultMaintenance(),
      masks,
    };
  },

  computed: {
    ...mapState({
      /** @returns {Maintenance} */
      maintenance: (/** @type {ROICalculatorState} */ state) => {
        return state.formValues.maintenance;
      },
    }),
  },

  watch: {
    maintenance: {
      handler: function (newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }

        this.form = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true,
    },
  },

  methods: {
    onFieldChange(formValue, stateValue) {
      if (stateValue == formValue) {
        return;
      }

      this.$store.commit(mutation('SET_MAINTENANCE_VALUES'), this.form);
    },
  },
};

/**
 * @typedef {import('../store/state').ROICalculatorState} ROICalculatorState
 * @typedef {import('../store/state').Maintenance} Maintenance
 */
</script>
